type BaseProjectTypeStructure = {
  typeInfo: {
    title: string;
    subTitle: string;
    description: string;
  };
  compositionList: string[];
  schedule: string;
};

export type ProjectTypeStructure = {
  consultationSignup: {
    href: string;
    src: string;
    label: string;
  };
  id: string;
  fixedPrice?: boolean;
  priceUnits?: string;
} & BaseProjectTypeStructure;

export const DEFAULT_DESCRIPTION =
  'Монтаж и\u00A0оборудование оплачиваются отдельно. Стоимость монтажа рассчитывается по\u00A0смете составленной для эскизного проекта или рабочей документации.';

export const PRELIMINARY_DESIGN: BaseProjectTypeStructure = {
  typeInfo: {
    title: 'Эскизный проект',
    subTitle: 'Подойдёт, если вы\u00A0заказываете установку под\u00A0ключ',
    description:
      'Эскизный проект содержит минимум технической информации, позволяет разработать техническое решение, подобрать оборудование и\u00A0рассчитать стоимость всего проекта.',
  },
  compositionList: [
    '— разработка основного технического решения;',
    '— размещение основного оборудования;',
    '— структурная схема основного оборудования;',
    '— спецификация товаров;',
    '— смета на монтажные работы.',
  ],
  schedule: '3 – 14 рабочих дней',
};

export const WORKING_DOCUMENTATION: BaseProjectTypeStructure = {
  typeInfo: {
    title: 'Рабочая документация',
    subTitle: 'Подойдёт, если вы\u00A0устанавливаете систему самостоятельно',
    description:
      'Проектная документация содержит всю техническую информацию и\u00A0аксонометрические схемы. Позволяет разработать техническое решение, подобрать оборудование и\u00A0рассчитать стоимость всего проекта.',
  },
  compositionList: [
    '— все части услуги эскизного проекта;',
    '— пояснительная записка;',
    '— расчёт магистралей и их элементов;',
    '— расчёт оконечного оборудования;',
    '— деталировка узлов основного оборудования;',
    '— размещение магистралей и их элементов;',
    '— аксонометрические схемы.',
  ],
  schedule: '3 – 28 рабочих дней',
};
